
    <div class="ticket-status" [ngClass]="{
      'success': value === statusList.successValue,
      'failure': value === statusList.failureValue,
      'pending': value === statusList.pendingValue
    }">
      {{ value | titlecase | translate }}
    </div>
  